<template>
   <mt-header title="百度地图">
     <router-link to="/" slot="left">
       <mt-button icon="back" v-on:click="buttonBackClick">返回</mt-button>
     </router-link>
     <mt-button icon="more" slot="right"></mt-button>
   </mt-header>

   <div class="list-group">

      <a v-for="arrFeedList in arrFeedLists" track-by="$index" class="list-group-item">
        <div class="row">
          <div class="col-md-2">
            <img v-bind:src="arrFeedList.brand_logo" width="120" height="90">
            <i class="fa fa-clock-o fa-1x" style="margin-top:20px;"> {{arrFeedList.news_update_time}}</i>
          </div>
        
          <div class="col-md-8">
            <h4 class="list-group-item-heading title_limit">{{arrFeedList.brand_name}}</h4>
            <p class="list-group-item-text line_limit">{{arrFeedList.news_content}}</p>
          </div>

          <div class="col-md-2">
             <i class="fa fa-angle-right fa-2x icon_right" style="margin-top:30%;"></i>
          </div>
        </div>
      </a>
   </div>

   <mt-tabbar v-model="selected" class="footer">
     <mt-tab-item id="资讯">
       <i class="fa fa-book fa-3x"></i>
       资讯
     </mt-tab-item>
     <mt-tab-item id="导航">
       <i class="fa fa-send fa-3x"></i>
       导航
     </mt-tab-item>
     <mt-tab-item id="我的">
       <i class="fa fa-user fa-3x"></i>
       用户
     </mt-tab-item>
     
   </mt-tabbar>
</template>

<script>
import lstore from '../store.js'
import Menu from './Menu'

export default {
    data () {
      return {
        msg: 'Welcome to DaiCrawler',
        arrFeedLists: JSON.parse(localStorage.getItem('weibo_key'))
      }
    },
 
  // watch:{
  //   lstore.car_home_feed_lists:
  // },
  methods:{
    buttonBackClick: function () {
        lstore.weibo_status = 0;
        lstore.hello_status = 1;
        lstore.menu_status = 1;
        lstore.setting_status = 0;
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.icon_right{
   float: right;
}

.icon_middle{
   top: 50%;
}
.title_limit{
  word-wrap: break-word;
  height: 20px;
  width: 320px;
  margin-top: 10px;
  overflow:hidden;
  text-overflow: ellipsis;
  white-space:nowrap;
}
.line_limit{
  word-wrap: break-word;
  height:90px;
  margin-top: 10px;
  text-overflow:ellipsis; 
  -o-text-overflow:ellipsis; 
  overflow: hidden; 
}
.footer{
  position:fixed;bottom:0px;left:0px;
}
</style>



// WEBPACK FOOTER //
// WeiBo.vue?74961f4e